(function(){
  var fmt=new Intl.NumberFormat('fr-CA',{style:'currency',currency:'CAD',maximumFractionDigits:0});
  var fmtTop=new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'});

  function getMap(c){
    var el=c.querySelector('.tariki-ss__vmap');
    if(!el)return null;
    try{return JSON.parse(el.textContent);}catch(e){return null;}
  }

  function getRefPrice(c){
    return parseFloat(c.dataset.sugg||'0');
  }

  /* Vrai quand la taille cliquee est celle de la piece en vitrine. Comparaison
     tolerante : data-taille peut valoir "40.0" quand data-num vaut "40", un jonc
     se mesure au dixieme de centimetre, et une saisie a la francaise peut porter
     une virgule decimale. */
  function isVitrineSize(c,num){
    var t=parseFloat(String(c.dataset.taille||'0').replace(',','.'));
    return t>0 && isFinite(num) && Math.abs(num-t)<0.01;
  }

  function updateMainPrice(c,prix){
    var overlay=document.getElementById('tariki-price-main');
    if(!overlay)return;
    var span=overlay.querySelector('.tariki-price-val');
    if(span)span.textContent=fmtTop.format(prix);
    overlay.classList.add('tariki-price-overlay--on');
    var pc=document.querySelector('product-price');
    if(pc)pc.classList.add('tariki-price-active');
  }

  function resetMainPrice(c){
    var overlay=document.getElementById('tariki-price-main');
    if(overlay)overlay.classList.remove('tariki-price-overlay--on');
    var pc=document.querySelector('product-price');
    if(pc)pc.classList.remove('tariki-price-active');
  }

  function setBoxes(c,priceTxt,wtTxt,sizeLbl){
    var boxes=c.querySelector('.tariki-ss__boxes');
    if(!boxes)return;
    var ep=boxes.querySelector('.tariki-ss__est-price');
    var ew=boxes.querySelector('.tariki-ss__est-weight');
    var es=boxes.querySelector('.tariki-ss__est-size');
    if(ep)ep.textContent=priceTxt;
    if(ew)ew.textContent=wtTxt;
    if(es)es.textContent=sizeLbl;
    boxes.hidden=false;
  }

  function setNoteVisible(c,v){
    var n=c.querySelector('.tariki-ss__est-note');
    if(n)n.hidden=!v;
  }

  /* Remplace le texte de la note par la version "taille Autre" (côté-bas) */
  function setNoteForAutre(c){
    var n=c.querySelector('.tariki-ss__est-note');
    if(!n)return;
    if(!n.dataset.orig)n.dataset.orig=n.textContent;
    n.textContent="Pour cette taille sur mesure, votre paiement initial correspond au tarif du format standard immédiatement inférieur. Une fois le bijou fabriqué, une facture d'ajustement basée sur le poids réel vous sera envoyée avant l'expédition — à la hausse comme à la baisse. Aucune marge cachée. Taxes en sus.";
  }

  /* Restaure le texte original de la note (pour tailles standard) */
  function restoreNote(c){
    var n=c.querySelector('.tariki-ss__est-note');
    if(n&&n.dataset.orig)n.textContent=n.dataset.orig;
  }

  /* --- Sécurité anti-mismatch : bloque l'ajout au panier quand aucune
     variante Shopify ne correspond réellement à la taille sélectionnée.
     Empêche de soumettre silencieusement l'ancien/mauvais variant_id
     (ex.: bouton "68 mm" sans variante correspondante dans le vmap). */
  function getAddToCartButtons(c){
    var form=c.closest('form');
    if(!form)return [];
    return Array.prototype.slice.call(form.querySelectorAll('[type="submit"], button[name="add"]'));
  }

  function getMismatchWarningEl(c){
    var warn=c.querySelector('.tariki-ss__mismatch-warning');
    if(!warn){
      warn=document.createElement('div');
      warn.className='tariki-ss__mismatch-warning';
      warn.style.cssText='color:#b03030;font-weight:600;margin-top:.6rem;padding:.6rem .8rem;border:1px solid #b03030;border-radius:4px;background:#fdecec;';
      warn.hidden=true;
      c.appendChild(warn);
    }
    return warn;
  }

  function lockCheckout(c,msg){
    c.dataset.tssBlocked='1';
    var form=c.closest('form');
    if(form){
      var idIn=form.querySelector('input[name="id"]');
      /* Vide l'input id : si jamais notre listener submit ne suffisait pas,
         Shopify refuse une soumission sans variant_id valide. */
      if(idIn)idIn.value='';
      c.dataset.tssVid='';
    }
    getAddToCartButtons(c).forEach(function(b){b.disabled=true;});
    var warn=getMismatchWarningEl(c);
    warn.textContent=msg||"Cette taille n'est pas disponible pour ce produit en ligne pour le moment. Merci de nous contacter pour la commander sur mesure.";
    warn.hidden=false;
  }

  /* Avertissement SANS vider input[name="id"].
     lockCheckout efface le variant_id : c'est voulu pour une taille qu'aucune
     variante ne peut servir, mais inadapte a une saisie hors bornes, ou l'on
     veut seulement refuser CETTE valeur en laissant la fiche vendable a la
     taille vitrine. Le drapeau tssBlocked reste pose : le listener 'submit'
     refuse l'ajout au panier quoi qu'il arrive. */
  function showSizeWarning(c,msg){
    c.dataset.tssBlocked='1';
    getAddToCartButtons(c).forEach(function(b){b.disabled=true;});
    var warn=getMismatchWarningEl(c);
    warn.textContent=msg;
    warn.hidden=false;
  }

  function clearSizeWarning(c){
    c.dataset.tssBlocked='0';
    getAddToCartButtons(c).forEach(function(b){b.disabled=false;});
    var warn=c.querySelector('.tariki-ss__mismatch-warning');
    if(warn)warn.hidden=true;
  }

  /* --- Validation de la taille libre saisie dans "Autre" ---
     Retourne null si la valeur est plausible, sinon le message a afficher.
     Les bornes viennent du Liquid (data-min / data-max / data-cat / data-unit) :
     elles dependent de la categorie ET du fait que le bijou soit un modele
     enfant. Avant, AUCUNE borne n'existait : le seul filtre etait num > 0. Une
     bague a 1000 affichait ainsi une estimation a 8 170 $ et 86,5 g pendant que
     Shopify facturait la variante de repli, et 6 tape en pensant "6 cm de tour
     de doigt" produisait une estimation d'apparence tout a fait normale. */
  function sizeError(c,num,raw){
    var min=parseFloat(c.dataset.min||'0');
    var max=parseFloat(c.dataset.max||'0');
    if(!min||!max)return null; /* categorie sans bornes connues : on ne juge pas */
    var unit=c.dataset.unit||'';
    var virg=function(n){return String(n).replace('.',',');};
    /* parseNum ne capture pas le signe : "-5" devenait 5. On relit le texte brut. */
    if(/-\s*\d/.test(String(raw||''))){
      return "Merci d'indiquer une taille positive.";
    }
    /* Erreur la plus frequente sur un jonc : saisir le tour de poignet a la
       place du diametre interieur. On donne la conversion plutot qu'un refus. */
    if((c.dataset.cat||'')==='jonc'&&num>=12&&num<=32){
      return "Il s'agit ici du diametre interieur du jonc, pas du tour de poignet. "
        +"Pour un tour de "+virg(num)+" cm, le diametre correspondant est d'environ "
        +virg(Math.round(num/Math.PI*10)/10)+" cm.";
    }
    if(num<min||num>max){
      return "Cette taille sort de ce que nous fabriquons ("+virg(min)+" a "+virg(max)+unit
        +"). Verifiez l'unite, ou ecrivez-nous : nous etudions toute demande particuliere.";
    }
    return null;
  }

  function unlockCheckout(c){
    c.dataset.tssBlocked='0';
    getAddToCartButtons(c).forEach(function(b){b.disabled=false;});
    var warn=c.querySelector('.tariki-ss__mismatch-warning');
    if(warn)warn.hidden=true;
  }

  function nearestVariant(c,num){
    var map=getMap(c);
    if(!map)return null;
    var best=null,bestDiff=Infinity;
    c.querySelectorAll('.tariki-sz[data-num]').forEach(function(btn){
      var sz=btn.getAttribute('data-size');
      var n=parseFloat(btn.getAttribute('data-num'));
      if(isNaN(n)||!sz||!map[sz])return;
      var d=Math.abs(n-num);
      if(d<bestDiff){bestDiff=d;best={price:map[sz].price,num:n};}
    });
    return best;
  }

  /* Trouve le variant standard le plus proche CÔTÉ BAS de la taille saisie.
     Exclut "En vitrine" et "__other__". Repli : le plus petit variant disponible
     PARMI CEUX DONT LE BOUTON CORRESPOND À UNE CLÉ DU vmap.
     Repli ultime : si AUCUN bouton de la grille ne correspond à une clé du vmap
     (ex.: grille en mm mais variantes Shopify nommées XS/S/M/L/XL), on prend la
     variante Shopify la moins chère du produit, afin de toujours garantir un
     variant_id valide pour le paiement — jamais de blocage silencieux. */
  function nearestVariantBelow(c,num){
    var map=getMap(c);
    if(!map)return null;
    var best=null,bestN=-Infinity;
    var smallN=Infinity,smallSz=null;
    c.querySelectorAll('.tariki-sz[data-num]').forEach(function(btn){
      var sz=btn.getAttribute('data-size');
      if(!sz||sz==='__other__'||sz==='En vitrine')return;
      var n=parseFloat(btn.getAttribute('data-num'));
      if(isNaN(n)||!map[sz])return;
      if(n<smallN){smallN=n;smallSz=sz;}
      if(n<=num&&n>bestN){bestN=n;best={sz:sz,num:n};}
    });
    if(!best&&smallSz)best={sz:smallSz,num:smallN};
    if(!best){
      /* Repli ultime : aucune clé de la grille ne correspond à une variante
         Shopify réelle (mismatch total, ex. grille mm / variantes lettrées).
         On prend la variante la moins chère pour garantir un checkout valide ;
         "num" n'a alors pas de correspondance connue (pas de tailleOverride). */
      var cheapestSz=null,cheapestPrice=Infinity;
      Object.keys(map).forEach(function(k){
        if(k==='En vitrine')return;
        if(map[k].price<cheapestPrice){cheapestPrice=map[k].price;cheapestSz=k;}
      });
      if(cheapestSz)best={sz:cheapestSz,num:null};
    }
    return best;
  }

  /* Sélectionne le variant côté bas (ou, à défaut, le moins cher) pour garantir
     un variant_id valide au checkout, tout en affichant l'estimation prorata
     ET la vraie taille choisie (sizeLbl) comme propriété "Taille" dans le panier.
     Utilisé à la fois pour "Autre" (taille saisie) et pour la grille standard
     quand aucune variante ne correspond exactement au bouton cliqué. */
  function applyFallbackVariant(c,num,sizeLbl){
    var map=getMap(c);
    if(!map)return false;
    var below=nearestVariantBelow(c,num);
    if(!below||!map[below.sz])return false;
    unlockCheckout(c);
    var form=c.closest('form');
    if(form){
      var idInput=form.querySelector('input[name="id"]');
      if(idInput){idInput.value=map[below.sz].id;c.dataset.tssVid=String(map[below.sz].id);}
      syncNativeSelector(form,below.sz);
    }
    /* Utilise le prix (et la taille, si connue) du variant de repli comme base d'interpolation */
    estimate(c,num,sizeLbl,map[below.sz].price,below.num||undefined);
    setNoteForAutre(c);
    return true;
  }

  /* Pour "Autre" : verrouille le variant côté bas pour le checkout,
     mais affiche l'estimation prorata pour la taille réellement saisie. */
  function estimateAutre(c,num,sizeLbl){
    if(!num||num<=0){
      /* Champ vide : on efface l'avertissement eventuel et on remet la fiche
         dans son etat vitrine, vendable. */
      resetToVitrineVariant(c);
      clearSizeWarning(c);
      showDefault(c);
      return;
    }
    var err=sizeError(c,num,sizeLbl);
    if(err){
      /* Ordre important : showDefault remet le cadre vitrine ET vide les
         proprietes de ligne (clearFormEstimProps), donc aucune taille ni aucun
         prix errone ne peut partir au panier. L'avertissement vient apres, pour
         qu'il reste visible. */
      resetToVitrineVariant(c);
      showDefault(c);
      showSizeWarning(c,err);
      return;
    }
    clearSizeWarning(c);
    /* Le libelle envoye au panier est NORMALISE. La chaine brute partait telle
       quelle dans properties[Taille] : "52 stp appelez-moi" arrivait ainsi dans
       la commande, alors que le calcul, lui, n'avait retenu que 52. */
    var lbl=String(num).replace('.',',')+(c.dataset.unit||'');
    if(c.dataset.hasvar==='1'){
      if(applyFallbackVariant(c,num,lbl))return;
      /* Aucun variant du tout pour ce produit "sur mesure" : impossible de
         garantir un variant_id valide -> on bloque plutôt que de deviner. */
      lockCheckout(c);
    }
    estimate(c,num,lbl);
  }

  function showRent(c,prix,estPoids){
    var el=c.querySelector('.tariki-ss__est-rent');
    if(!el)return;
    var cout      =parseFloat(c.dataset.cout      ||'0');
    var ecrin     =parseFloat(c.dataset.ecrin     ||'0');
    var mainOeuvre=parseFloat(c.dataset.mainOeuvre||'0');
    var fraisVente=parseFloat(c.dataset.fraisVente||'0');
    var fraisFix  =parseFloat(c.dataset.fraisFix  ||'0');
    var taxes     =parseFloat(c.dataset.taxes     ||'0');
    var rentMin   =parseFloat(c.dataset.rentMin   ||'30');
    var rentMax   =parseFloat(c.dataset.rentMax   ||'50');
    if(!cout||!estPoids||!prix){el.hidden=true;return;}
    var promo=parseFloat(c.dataset.promo||'0');
    var promoActive=c.dataset.promoActive==='1';
    var prixNet=prix*(promoActive&&promo>0?(100-promo)/100:1);
    var coutTotal   =cout*estPoids+mainOeuvre+ecrin;
    var prixTTC     =prixNet*(1+taxes/100);
    var fraisShopify=prixTTC*(fraisVente/100)+fraisFix;
    var revenuNet   =prixNet-fraisShopify;
    var marge=Math.round((revenuNet-coutTotal)/revenuNet*100);
    var pct=el.querySelector('.tariki-ss__rent-pct');
    var fill=el.querySelector('.tariki-ss__rent-fill');
    if(pct){
      pct.textContent=marge+'%';
      pct.className='tariki-ss__rent-pct';
      if(marge>=rentMax)     pct.classList.add('tariki-ss__rent-pct--good');
      else if(marge>=rentMin)pct.classList.add('tariki-ss__rent-pct--warn');
      else                   pct.classList.add('tariki-ss__rent-pct--bad');
    }
    if(fill){
      fill.style.width=Math.min(100,Math.max(0,marge))+'%';
      fill.style.background=marge>=rentMax?'#1e7c1e':marge>=rentMin?'#b07800':'#c0392b';
    }
    /* Prix suggéré pour atteindre la fourchette de rentabilité cible */
    var sugg=el.querySelector('.tariki-ss__rent-sugg');
    if(sugg){
      var promoFactor=promoActive&&promo>0?(100-promo)/100:1;
      var k=1-(1+taxes/100)*fraisVente/100; /* facteur revenu net / prixNet */
      function prixPourMarge(m){return(coutTotal/(1-m)+fraisFix)/k/promoFactor;}
      var pMin=Math.ceil(prixPourMarge(rentMin/100)/5)*5;
      var pMax=Math.ceil(prixPourMarge(rentMax/100)/5)*5;
      if(marge>=rentMin&&marge<=rentMax){
        sugg.textContent='✓ Prix dans la fourchette cible ('+rentMin+'–'+rentMax+'%)';
        sugg.style.color='#1e7c1e';
      }else{
        sugg.textContent='Prix suggéré : '+fmt.format(pMin)+' – '+fmt.format(pMax)+' $ CAD';
        sugg.style.color='#555';
      }
    }
    el.hidden=false;
  }

  function weightTxt(c,num,isRef){
    var poids=parseFloat(c.dataset.poids||'0');
    var taille=parseFloat(c.dataset.taille||'0');
    if(!poids)return '';
    if(isRef||!num||!taille){
      return poids.toLocaleString('fr-CA')+' g d'+String.fromCharCode(8217)+'or 18 carats';
    }
    var pest=Math.round(poids*(num/taille)*10)/10;
    return '≈ '+pest.toLocaleString('fr-CA')+' g d'+String.fromCharCode(8217)+'or 18 carats';
  }

  function calcEstPoids(c,num,isRef){
    var poids=parseFloat(c.dataset.poids||'0');
    var taille=parseFloat(c.dataset.taille||'0');
    if(!poids||!taille||!num)return poids;
    if(isRef)return poids;
    return Math.round(poids*(num/taille)*10)/10;
  }

  function calcPrix(c,num,taille,isRef){
    var base=getRefPrice(c);
    if(base&&taille&&num){
      return isRef?base:Math.ceil(base*(num/taille)/5)*5;
    }
    return 0;
  }

  function showDefault(c){
    var ref=c.querySelector('.tariki-ss__ref');
    if(ref){
      /* Pour hasvar : le prix du cadre EN VITRINE = prix Shopify réel du variant "En vitrine"
         (= prix sans promotion — la promo ne s'applique qu'au panier).
         Pour non-hasvar : fallback sur data-sugg (prix suggéré dans le metafield). */
      var priceBase=getRefPrice(c);
      if(c.dataset.hasvar==='1'){var _m=getMap(c);if(_m&&_m['En vitrine'])priceBase=_m['En vitrine'].price;}
      var refPriceEl=ref.querySelector('.tariki-ss__ref-price');
      if(refPriceEl&&priceBase)refPriceEl.textContent=fmt.format(Math.round(priceBase));
      var refWeightEl=ref.querySelector('.tariki-ss__ref-weight');
      var poids=parseFloat(c.dataset.poids||'0');
      if(refWeightEl&&poids)refWeightEl.textContent=poids.toLocaleString('fr-CA')+' g d'+String.fromCharCode(8217)+'or 18 carats';
    }
    var boxes=c.querySelector('.tariki-ss__boxes');
    if(boxes)boxes.hidden=true;
    var rent=c.querySelector('.tariki-ss__est-rent');
    if(rent)rent.hidden=true;
    restoreNote(c);
    setNoteVisible(c,false);
    resetMainPrice(c);
    /* Remettre l'apparence normale du bouton vitrine */
    c.classList.remove('tariki-novitrine');
    clearFormEstimProps(c);
  }

  /* Met à jour SILENCIEUSEMENT le sélecteur natif Shopify (select ou radio)
     SANS déclencher d'événement 'change' pour éviter que le handler
     <variant-selects> du thème n'écrase notre input[name="id"].
     La synchronisation finale est garantie par le listener 'submit' en capture. */
  function syncNativeSelector(form,sz){
    if(!form||!sz)return;
    var sels=form.querySelectorAll('select[name^="options["]');
    for(var i=0;i<sels.length;i++){
      var opts=sels[i].options;
      for(var j=0;j<opts.length;j++){
        if(opts[j].value===sz){
          sels[i].value=sz;
          /* Déclenche l'événement natif Shopify pour que le thème mette à jour
             l'affichage du prix (avec barré) — notre capture listener 'submit'
             garantit le bon variant_id au moment du checkout quoi qu'il arrive. */
          sels[i].dispatchEvent(new Event('change',{bubbles:true}));
          return;
        }
      }
    }
    var radios=form.querySelectorAll('input[type="radio"][name^="options["]');
    for(var k=0;k<radios.length;k++){
      if(radios[k].value===sz&&!radios[k].checked){
        radios[k].checked=true;
        radios[k].dispatchEvent(new Event('change',{bubbles:true}));
        return;
      }
    }
  }

  function selectVariant(c,sz,num){
    var map=getMap(c);
    if(!map||!map[sz])return false;
    unlockCheckout(c);
    var form=c.closest('form');
    if(form){
      var idInput=form.querySelector('input[name="id"]');
      if(idInput){idInput.value=map[sz].id;c.dataset.tssVid=String(map[sz].id);}
      syncNativeSelector(form,sz);
      /* Ré-impose notre variant après dispatchEvent (Shopify a pu écrire input[name="id"]) */
      if(idInput)idInput.value=map[sz].id;
    }
    var taille=parseFloat(c.dataset.taille||'0');
    var isRef=(num===taille);
    var pest=calcEstPoids(c,num,isRef);
    /* Pour hasvar : afficher le prix Shopify réel dans la box SUR MESURE
       (cohérent avec l'affichage natif mis à jour par l'événement change) ;
       pour non-hasvar : calcul proportionnel sur ss_sugg. */
    var prix=(c.dataset.hasvar==='1')?map[sz].price:(calcPrix(c,num,taille,isRef)||map[sz].price);
    setBoxes(c,fmt.format(prix),weightTxt(c,num,isRef),sz);
    showRent(c,prix,pest);
    restoreNote(c);
    setNoteVisible(c,true);
    /* Toujours mettre à jour l'overlay — syncNativeSelector génère un événement non-isTrusted
       que Dawn peut ignorer, donc le prix natif ne se met pas à jour de façon fiable. */
    updateMainPrice(c,prix);
    clearFormEstimProps(c);
    return true;
  }

  function estimate(c,num,sizeLbl,baseOverride,tailleOverride){
    var poids=parseFloat(c.dataset.poids||'0');
    var taille=parseFloat(c.dataset.taille||'0');
    var base=baseOverride||getRefPrice(c);
    var priceTaille=tailleOverride||taille;
    if(!base&&c.dataset.hasvar==='1'){
      var nv=nearestVariant(c,num);
      if(nv){base=nv.price;priceTaille=nv.num;}
    }
    if(!poids||!taille||!base||!priceTaille||!num||num<=0){showDefault(c);return;}
    var isRef=(num===taille);
    var prix=isRef?base:Math.ceil(base*(num/priceTaille)/5)*5;
    var pest=Math.round(poids*(num/taille)*10)/10;
    var lbl=sizeLbl||String(num);
    setBoxes(c,fmt.format(prix),weightTxt(c,num,isRef),lbl);
    showRent(c,prix,pest);
    setNoteVisible(c,true);
    /* Toujours afficher le prix estimé via l'overlay — pour hasvar et non-hasvar. */
    updateMainPrice(c,prix);
    setFormEstimProps(c,lbl,prix);
  }

  function parseNum(v){
    var m=(v||'').replace(',','.').match(/\d+(?:\.\d+)?/);
    return m?parseFloat(m[0]):null;
  }

  /* Pour hasvar=1 + "Autre": remettre le variant vitrine comme placeholder
     pour eviter qu'une taille precedemment selectionnee reste dans le panier */
  function resetToVitrineVariant(c){
    if(c.dataset.hasvar!=='1')return;
    var map=getMap(c);
    if(!map)return;
    var form=c.closest('form');
    if(!form)return;
    var idInput=form.querySelector('input[name="id"]');
    if(!idInput)return;
    /* Essai direct : cle exacte du bouton vitrine */
    var vBtn=c.querySelector('.tariki-sz--vitrine');
    if(vBtn){
      var vKey=vBtn.getAttribute('data-size');
      if(vKey&&map[vKey]){idInput.value=map[vKey].id;c.dataset.tssVid=String(map[vKey].id);syncNativeSelector(form,vKey);return;}
    }
    /* Repli : variante la plus proche de la taille de base */
    var taille=parseFloat(c.dataset.taille||'0');
    if(!taille)return;
    var best=null,bestDiff=Infinity;
    c.querySelectorAll('.tariki-sz[data-num]').forEach(function(btn){
      var sz=btn.getAttribute('data-size');
      var n=parseFloat(btn.getAttribute('data-num'));
      if(isNaN(n)||!sz||!map[sz])return;
      var d=Math.abs(n-taille);
      if(d<bestDiff){bestDiff=d;best=map[sz].id;}
    });
    if(best){idInput.value=best;c.dataset.tssVid=String(best);}
  }

  /* --- Propriétés de panier pour tailles estimées --- */
  function setFormEstimProps(c,tailleLbl,prix){
    var form=c.closest('form');
    if(!form)return;
    var pt=form.querySelector('input[name="properties[Taille]"]');
    if(!pt){pt=document.createElement('input');pt.type='hidden';pt.name='properties[Taille]';form.appendChild(pt);}
    pt.value=tailleLbl||'';
    /* IMPORTANT : ce champ (input.tariki-ss__inp) existe déjà dans le template
       pour la case "Autre" et reste désactivé par défaut — un input désactivé
       n'est JAMAIS soumis avec le formulaire. On l'active explicitement dès
       qu'on lui donne une vraie valeur à afficher dans le panier, sinon la
       taille sélectionnée disparaît silencieusement du panier. */
    pt.disabled=!tailleLbl;
    var pp=form.querySelector('input[name="properties[Prix estimé]"]');
    if(!pp){pp=document.createElement('input');pp.type='hidden';pp.name='properties[Prix estimé]';form.appendChild(pp);}
    pp.value=prix?fmt.format(prix):'';
    pp.disabled=!prix;
  }

  function clearFormEstimProps(c){
    var form=c.closest('form');
    if(!form)return;
    ['properties[Taille]','properties[Prix estimé]'].forEach(function(nm){
      var el=form.querySelector('input[name="'+nm+'"]');
      if(el){el.value='';el.disabled=true;}
    });
  }

  function init(){
    document.querySelectorAll('.tariki-ss').forEach(function(c){
      if(c._tss)return; c._tss=1;

      var btns=c.querySelectorAll('.tariki-sz');
      var inp=c.querySelector('.tariki-ss__inp');
      var lbl=c.querySelector('.tariki-ss__sel');
      var otherWrap=c.querySelector('.tariki-ss__other-wrap');
      var otherInput=c.querySelector('.tariki-ss__other-input');

      /* Listener en phase CAPTURE sur le formulaire : garantit que notre
         input[name="id"] est correct au moment où Shopify lit les données du form,
         quoi que le thème ait pu faire entre notre sélection et la soumission.
         Si une sélection est bloquée (aucune variante ne correspond réellement
         à la taille choisie), on bloque aussi la soumission ici en dernier
         recours, même si le bouton d'ajout a été réactivé entre-temps. */
      var initForm=c.closest('form');
      /* Mémorise le variant initial (depuis l'URL) pour pouvoir le restaurer
         si le bouton "En vitrine" est cliqué sans variant correspondant. */
      var initVidVal='';
      if(initForm){var _initIdEl=initForm.querySelector('input[name="id"]');if(_initIdEl)initVidVal=_initIdEl.value||'';}
      if(initForm&&!initForm._tssSubmit){
        initForm._tssSubmit=1;
        initForm.addEventListener('submit',function(ev){
          if(c.dataset.tssBlocked==='1'){
            ev.preventDefault();
            ev.stopImmediatePropagation();
            lockCheckout(c);
            return;
          }
          var vid=c.dataset.tssVid;
          if(vid){
            var idIn=initForm.querySelector('input[name="id"]');
            if(idIn)idIn.value=vid;
          }
        },true);
      }

      /* Injecte l'overlay de prix (#tariki-price-main) et le badge TPS+TVQ
         DANS <product-price> — une seule fois par page.
         Placer ces éléments À L'INTÉRIEUR de product-price garantit :
         1) que updateMainPrice/resetMainPrice trouvent l'overlay via closest()
         2) que le badge apparaît près du prix natif et non près du cadre En vitrine */
      /* Injecte l'overlay (#tariki-price-main) et le badge TPS+TVQ
         APRÈS <product-price> (siblings dans le DOM), pas à l'intérieur.
         Cela évite que le re-render de product-price (déclenché par syncNativeSelector)
         ne supprime nos éléments injectés. */
      var _pc=document.querySelector('product-price');
      if(_pc){
        if(!document.getElementById('tariki-price-main')){
          var _ov=document.createElement('div');
          _ov.id='tariki-price-main';
          var _pvSpan=document.createElement('span');
          _pvSpan.className='tariki-price-val';
          _ov.appendChild(_pvSpan);
          _pc.insertAdjacentElement('afterend',_ov);
        }
        if(!document.querySelector('.tariki-top-badge')){
          var _promo=parseFloat(c.dataset.promo||'0');
          var _taxes=parseFloat(c.dataset.taxes||'0');
          var _taxEquiv=_taxes>0?Math.round(_taxes*100/(_taxes+100)*100)/100:0;
          var _promoActive=c.dataset.promoActive==='1';
          if(_promoActive&&_promo>0){
            if(!document.querySelector('#tariki-top-badge-css')){
              var _css=document.createElement('style');
              _css.id='tariki-top-badge-css';
              _css.textContent='.tariki-top-badge{display:block;font-size:.72rem;font-weight:700;padding:.18rem .6rem;border-radius:3px;margin-top:.4rem;letter-spacing:.04em;width:fit-content;}.tariki-top-badge--tps{background:#1b5e20;color:#fff;}.tariki-top-badge--solde{background:#b03030;color:#fff;}';
              document.head.appendChild(_css);
            }
            var _badge=document.createElement('div');
            if(Math.abs(_promo-_taxEquiv)<0.01){
              _badge.className='tariki-top-badge tariki-top-badge--tps';
              _badge.textContent='TPS + TVQ offertes';
            }else{
              _badge.className='tariki-top-badge tariki-top-badge--solde';
              _badge.textContent='SOLDE';
            }
            /* Insérer après l'overlay (ou après product-price si l'overlay n'existe pas encore) */
            var _ancre=document.getElementById('tariki-price-main')||_pc;
            _ancre.insertAdjacentElement('afterend',_badge);
          }
        }
      }

      showDefault(c);

      btns.forEach(function(btn){
        btn.addEventListener('click',function(){
          btns.forEach(function(b){b.classList.remove('on');});
          btn.classList.add('on');

          /* Supprime l'aspect "actif" du bouton vitrine quand un autre bouton est selectionne */
          c.classList.toggle('tariki-novitrine',!btn.classList.contains('tariki-sz--vitrine'));

          var sz=btn.getAttribute('data-size');
          if(sz==='__other__'){
            if(otherWrap){otherWrap.hidden=false;}
            /* hasvar=1: remettre variant vitrine pour eviter double taille dans le panier */
            resetToVitrineVariant(c);
            unlockCheckout(c);
            if(otherInput){
              otherInput.focus();
              var v=otherInput.value.trim();
              if(inp){inp.value=v;inp.disabled=!v;}
              if(lbl){lbl.textContent=v?v:'Preciser ci-dessous';lbl.classList.toggle('on',!!v);}
              estimateAutre(c,parseNum(v),v||'');
            }
            return;
          }
          if(otherWrap){otherWrap.hidden=true;}
          var num=parseFloat(btn.getAttribute('data-num'));
          if(c.dataset.hasvar==='1'){
            if(inp){inp.value='';inp.disabled=true;}
            if(lbl){lbl.textContent=sz;lbl.classList.add('on');}
            if(btn.classList.contains('tariki-sz--vitrine')){
              /* Bouton "En vitrine" — toujours afficher le cadre EN VITRINE (état par défaut).
                 Si "En vitrine" est un vrai variant Shopify : le sélectionner dans le formulaire
                 (met à jour le panier) mais afficher quand même le cadre EN VITRINE.
                 Si "En vitrine" n'est PAS un variant : restaurer le variant initial et
                 afficher ss_sugg via l'overlay. */
              unlockCheckout(c);
              var _vmap=getMap(c);
              if(_vmap&&_vmap[sz]){
                selectVariant(c,sz,num); /* sélectionne le variant En vitrine dans le form */
              }else{
                c.dataset.tssVid='';
                if(initForm){var _iv=initForm.querySelector('input[name="id"]');if(_iv&&initVidVal)_iv.value=initVidVal;}
              }
              showDefault(c); /* affiche cadre EN VITRINE, masque boxes, appelle resetMainPrice */
              /* Toujours afficher le prix du variant "En vitrine" via l'overlay pour garantir
                 que le prix en haut de page correspond à la taille sélectionnée.
                 syncNativeSelector peut ne pas être traité par le thème (événement non isTrusted). */
              var _vitrinePrice=(_vmap&&_vmap[sz])?_vmap[sz].price:getRefPrice(c);
              updateMainPrice(c,_vitrinePrice);
            }else if(isVitrineSize(c,num)){
              /* Cette taille EST celle de la piece en vitrine : le bijou existe deja,
                 il part sous 4 a 8 jours. Afficher le cadre SUR MESURE et son delai de
                 3 a 6 semaines serait donc faux. On emprunte exactement le chemin du
                 bouton "En vitrine" : meme variante mise au panier, meme cadre affiche,
                 meme delai annonce. Sans ce branchement, selectVariant affichait le
                 cadre SUR MESURE et rien ne le remasquait ensuite. */
              unlockCheckout(c);
              var _vmRef=getMap(c);
              if(_vmRef&&_vmRef[sz]){
                selectVariant(c,sz,num);
              }else if(_vmRef&&_vmRef['En vitrine']){
                selectVariant(c,'En vitrine',num);
              }
              showDefault(c);
              var _prixRef=(_vmRef&&_vmRef[sz])?_vmRef[sz].price:((_vmRef&&_vmRef['En vitrine'])?_vmRef['En vitrine'].price:getRefPrice(c));
              updateMainPrice(c,_prixRef);
            }else{
              /* Taille standard : effacer l'overlay avant le changement de variant */
              resetMainPrice(c);
              if(!selectVariant(c,sz,num)){
                /* Aucune variante Shopify ne correspond exactement à ce bouton
                   (ex. grille en mm mais variantes lettrées) : on ne soumet PLUS
                   silencieusement l'ancien variant/prix. À la place, on sélectionne
                   un variant de repli (le plus proche côté bas, ou à défaut le moins
                   cher) pour garantir un paiement valide, on affiche la VRAIE taille
                   choisie (ex. "68 mm") comme propriété dans le panier, et on prévient
                   que le montant est un acompte ajusté après fabrication — comme pour
                   la case "Autre". Si même ce repli est impossible (aucune variante
                   du tout), on bloque en dernier recours plutôt que de deviner. */
                if(!applyFallbackVariant(c,num,sz)){
                  lockCheckout(c,"Cette taille (" + sz + ") n'est pas disponible pour ce produit pour le moment. Merci de nous contacter pour la commander sur mesure.");
                  estimate(c,num,sz);
                }
              }
            }
          }else{
            unlockCheckout(c);
            if(inp){inp.value=sz;inp.disabled=false;}
            if(lbl){lbl.textContent=sz;lbl.classList.add('on');}
            estimate(c,num,sz);
          }
        });
      });

      if(otherInput){
        otherInput.addEventListener('input',function(){
          var v=otherInput.value.trim();
          if(inp){inp.value=v;inp.disabled=!v;}
          if(lbl){lbl.textContent=v?v:'Preciser ci-dessous';lbl.classList.toggle('on',!!v);}
          estimateAutre(c,parseNum(v),v||'');
        });
      }

      var vitrineBtn=c.querySelector('.tariki-sz--vitrine');
      if(vitrineBtn){
        setTimeout(function(){
          vitrineBtn.click();
        },100);
      }
    });
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:block:load',init);
  document.addEventListener('shopify:section:load',init);
})();
